import {AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {State} from '../../../../store';
import * as selectors from '../../../../store/auth/authentication.selectors';
import * as actions from '../../../../store/auth/authentication.actions';
import {environment} from '../../../../../environments/environment';
import * as selectorsApp from '../../../../store/app/app.selectors';
import {selectAppViewPort} from '../../../../store/app/app.selectors';
import * as appActions from '../../../../store/app/app.actions';
import {FORBIDDEN_DOMAIN_EMAILS} from '../../../../constants/forbidden-emails';

@Component({
  selector: 'app-register-step1',
  templateUrl: './register-step1.component.html',
  styleUrls: ['./register-step1.component.scss'],
})
export class RegisterStep1Component implements OnInit, OnDestroy, AfterViewChecked {
  signup_email_form: FormGroup;
  loading_spinner = false;

  error_message = '';
  platformBrandLogo = '';
  platformName = '';
  platformLandingPage = '';
  viewport = '';

  private subscriptions = [];

  constructor(public store: Store<State>,
              private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.store.select(selectAppViewPort).subscribe(result => {
      this.viewport = result;
    });
    this.store.dispatch(appActions.getPublicUserGroup({typeUserGroup: 'platform_id',  queryValue: environment.platform_id }));
    this.signup_email_form = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(
          "^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$"
        ),
        this.checkIfEmailIsForbidden.bind(this),
      ]),
    });

    this.subscriptions.push(
      this.store
        .select(selectors.selectSignUpStep1Error)
        .subscribe(errMessage => {
          this.error_message = errMessage;
        }),
      this.store
        .select(selectors.selectSignUpStep1Loading)
        .subscribe(loading => {
          this.loading_spinner = loading;
        }),
    );
  }

  ngAfterViewChecked() {
    this.subscriptions.push(
        this.store.select(selectorsApp.selectUserGroup).subscribe(userGroup => {
          if (userGroup !== null ) {
            this.platformBrandLogo = userGroup.logo_login_url;
            this.platformName = userGroup.platform_name;
            this.platformLandingPage = userGroup.landing_page;
            this.cdr.detectChanges();
          }
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.store.dispatch(actions.clearErrors());
  }

  signUpEmail(): void {
    if (this.signup_email_form.status !== 'INVALID') {
      this.signup_email_form.controls['email'].setValue(
        this.signup_email_form.controls['email'].value.toLowerCase()
      );
      this.store.dispatch(
        actions.signUpStep1({ email: this.signup_email_form.value })
      );
    }
  }

  /**
   * Check if email is forbidden and sets error if so
   * @param {FormControl} control The form control to check
   * @return {null | object} All custom validators return null if not detected custom error: object
   */
  checkIfEmailIsForbidden(control: FormControl): object | null {
    for (
        let domain_index = 0;
        domain_index < FORBIDDEN_DOMAIN_EMAILS.length;
        domain_index++
    ) {
      if (
          control.value.includes(FORBIDDEN_DOMAIN_EMAILS[domain_index]) === true
      ) {
        return {
          forbidden_email: true,
        };
      }
    }
    return null;
  }
}
